import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
const DEFAULT_INTERVAL_MS = 3500;
// Cycles through the images on a timer, with an n/N counter when there is more than one.
const RotatingThumb = (props) => {
    var _a;
    const [stateIndex, setIndex] = useState(0);
    const count = props.srcs.length;
    const intervalMs = (_a = props.intervalMs) !== null && _a !== void 0 ? _a : DEFAULT_INTERVAL_MS;
    useEffect(() => {
        if (count < 2)
            return undefined;
        const timer = window.setInterval(() => setIndex(i => (i + 1) % count), intervalMs);
        return () => window.clearInterval(timer);
    }, [count, intervalMs]);
    const index = count === 0 ? 0 : stateIndex % count;
    return count === 0 ? null : _jsx(_Fragment, { children: _jsxs("div", { className: "rotating-thumb", children: [_jsx("img", { src: props.srcs[index], alt: props.alt, className: props.className, style: props.style }), count > 1 && _jsxs("span", { className: "rotating-thumb__count", children: [index + 1, "/", count] })] }) });
};
export default RotatingThumb;
